<div class="container-fluid" #content id="modal-basic-title">
    <div class="row">
        <div class="col-sm-12">
            <div class="">
                <h2 class="title-page" *ngIf="!this.role">Gestion des Utilisateurs</h2>
                <h2 class="title-page" *ngIf="this.role === 'Provider'">Gestion des fournisseurs</h2>
                <h2 class="title-page" *ngIf="this.role === 'Shop'">Gestion des adhérents</h2>
                <!-- Sort and search bar -->
                <div class="filter-search justify-content-between">
                    <!-- Sort toggle-->
                    <!-- <ngbDropdown ngbDropdown class="d-inline-block filter-block flex-33">
                        <button (click)="toggleFilter()" type="button" class="btn btn-sort filter-bar form-control">Trier par</button>
                    </ngbDropdown> -->
                    <!-- Search bar -->
                    <div class="search-block d-flex align-items-center">
                        <div>
                            <input
                                #search
                                id="search"
                                type="text"
                                class="form-control"
                                placeholder="Recherche..."
                                aria-label="Search"
                                aria-describedby="basic-addon1"
                            >
                            <div class="btn-reset-search" (click)="resetSearch()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 					  stroke-linejoin="round" class="feather feather-delete" _ngcontent-bnt-c218="">
                                    <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path>
                                    <line x1="18" y1="9" x2="12" y2="15"></line>
                                    <line x1="12" y1="9" x2="18" y2="15"></line>
                                </svg>
                            </div>
                        </div>
                            <!-- Bouton valider -->
                        <div class="btn-submit">
                            <button type="button" class="btn btn-submit ng-star-inserted btn-success btn-submit-search"  (click)="onSearchChange(searchField)">Valider</button>
                        </div>
                    </div>


                    <!-- bouton ajouter -->
                    <div class="btn-create-block">
                        <button *ngIf="this.role === 'Provider'" type="button" class="btn btn-create" (click)="addUser()">
                            <i class="fa fa-plus-circle"></i>
                            Ajouter un fournisseur
                        </button>
                        <button *ngIf="this.role === 'Shop'" type="button" class="btn btn-create" (click)="addUser()">
                            <i class="fa fa-plus-circle"></i>
                            Ajouter un adhérent
                        </button>
                    </div>
                </div>
                <!-- <div id="table-filter" style="display: none">
                    <mat-radio-group class="table-filter" (change)="onChangeFilter($event)"> -->
                        <!-- Sort by last connect date -->
                        <!-- <div class="check-date">
                            <label class="title">Date</label>
                            <div class="filter-item">
                                <mat-radio-button color="primary" value="newest-date">De la plus récente à la plus ancienne</mat-radio-button>
                                <mat-radio-button color="primary" value="oldest-date">De la plus ancienne à la plus récente</mat-radio-button>
                            </div>
                        </div> -->
                        <!-- Sort by last name -->
                        <!-- <div class="etat-demande">
                            <label class="title">Nom</label>
                            <div class="filter-item">
                                <mat-radio-button color="primary" value="asc-name">De A à Z</mat-radio-button>
                                <mat-radio-button color="primary" value="desc-name">De Z à A</mat-radio-button>
                            </div>

                        </div>
                    </mat-radio-group>
                </div> -->
                <div class="table">
                    <!-- Table -->
                    <ngx-datatable
                        [rows]="dataTableUserDisplay"
                        class="material striped"
                        [columnMode]="ColumnMode.force"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="'auto'"
                        [columns]="columns"
                        [messages]="empty_msgFr">
                        <!-- Columns -->
                        <ngx-datatable-column *ngFor="let column of columns; let i = index" name="{{ column.name }}" prop="{{ column.prop }}">
                           <!-- Rows -->
                            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                <span>{{ value }}</span>
                                <!-- BTN voir -->
                                <span *ngIf="column.prop === 'btn_show'" class="group_btn_show_edit">
                                    <button class="btn_bo btn_show" (click)="showUserInfo(row)">
                                        <i class="fa fa-eye fa-lg"></i>
                                        Voir
                                    </button>
                                    <button class="btn_bo btn_payment" (click)="editUserInfo(row)">
                                        <i class="fa fa-edit fa-lg"></i>
                                        Modifier
                                    </button>
                                    <button *ngIf="this.role === 'Shop'" [disabled]="!row.isWeb" class="btn_bo btn_mangoPay" (click)="editUserPayment(row)">
                                        <i class="fa fa-credit-card fa-lg"></i>
                                        <!-- Paiement -->
                                    </button>
                                </span>
                                <!-- BTN password -->
                                <!-- <span *ngIf="column.prop === 'btn_pwd'">
                                    <button class="btn_bo btn_pwd" >
                                    <i class="fa fa-lock fa-lg"></i>
                                    Changer
                                    </button>
                                </span> -->

                                <!-- BTN activate -->
                                <span *ngIf="column.prop === 'btn_acc'">
                                    <button *ngIf="row.isActive === false" class="btn_bo btn_active" (click)="toggleUser(row)">
                                        <i class="fa fa-lock fa-lg"></i>
                                        Activer
                                    </button>
                                    <button *ngIf="row.isActive === true" class="btn_bo btn_deactive" (click)="toggleUser(row)">
                                        <i class="fa fa-times-circle-o fa-lg"></i>
                                        Désactiver
                                    </button>

                                    <button class="btn_bo btn_deactive" (click)="deleteUser(row)">
                                        <i class="fa fa-times-circle-o fa-lg"></i>
                                        Supprimer
                                    </button>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
                <!-- Pagination bar -->
                <div class="pagination-top">
                    <ngb-pagination class="d-flex justify-content-center" [pageSize]="pageSize" [collectionSize]="collectionSize" [(page)]="currentPage" [maxSize]="5" [rotate]="true"
                                    [ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange()"></ngb-pagination>
                </div>

                <ng-template #hint>
                    <div class="modal-header">
                      <div class="title">
                        <h2 class="modal-title">Les rôles</h2>
                      </div>
                      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body d-flex flex-column">
                        <h6>Afin de gérer les utilisateurs, les commandes ainsi que les clients, un utilisateur possède un rôle définit parmis les suivants :</h6>
                        <h6>
                            <li>
                                <span class="title-hint">Administrateur</span> : Cet utilisateur voit toute la liste des utilisateurs, des commandes ainsi que des clients. Il est en capacité d’ajouter un utilisateur.
                            </li>
                            <li>
                                <span class="title-hint">Adhérent</span> : Ce rôle voit les listes de commandes et de clients qui lui sont affiliées. Il peut également modifier l’état d’une commande concernant la réception du paiement.
                            </li>
                            <li>
                                <span class="title-hint">Fournisseur</span> : Ce rôle permet d’avoir la vision et de pouvoir gérer ses commandes. Il est en capacité de refuser une commande en cas de rupture de stock et de justifier son refus
                            </li>
                        </h6>
                    </div>
                  </ng-template>
            </div>
        </div>
    </div>
</div>
